import { HomeQualityCheckQueries } from '@/graphql/queries/homeQualityChecks.queries'
import { useGraphql } from '@/hooks/useGraphql'
import { HomeQualityCheck } from '@/types/HomeQualityCheck'

export function useHomeQualityCheck({ homeQualityCheckId }: { homeQualityCheckId?: number }) {
  const homeQualityCheckQuery = useGraphql<{ homeQualityCheck: HomeQualityCheck }>(
    HomeQualityCheckQueries.QUERY_KEYS.getHomeQualityCheck,
    HomeQualityCheckQueries.getHomeQualityCheck(),
    { id: homeQualityCheckId },
    {
      enabled: !!homeQualityCheckId,
      refetchOnMount: 'always',
    },
  )
  return homeQualityCheckQuery
}
